import api from 'Application/api/api';

/**
 * @param data Accepts an object with the following format:
 * {
 *   name: '',
 *   areaIds: [],
 * }
 * @param cancelToken
 */
const createInstruction = (data, cancelToken = null) =>
    api.post('education/instructions', data, { cancelToken });

export default createInstruction;
